// achievement-registry.ts — Client-side mirror of the server's achievementRegistry.
// Keep in sync with game-server/modules/ponder-flight-game/achievements.go.
// imageId must match a key in portal-frontend/src/assets/achievements/achievement-images.ts.
// nameKey / descriptionKey must exist in all three locale files.

interface AchievementDef {
  imageId: string;
  nameKey: string;
  descriptionKey: string;
}

export const ACHIEVEMENT_REGISTRY: Record<string, AchievementDef> = {
  teamwork_excellence: {
    imageId: 'teamwork-excellence',
    nameKey: 'achievements.teamworkExcellence.name',
    descriptionKey: 'achievements.teamworkExcellence.description',
  },
  'intro-aviation-graduate': {
    imageId: 'teamwork-excellence', // placeholder until specific art is added
    nameKey: 'achievements.introAviationGraduate.name',
    descriptionKey: 'achievements.introAviationGraduate.description',
  },
};
